import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';

import es from './translations/es.json';
import en from './translations/en.json';
import pl from './translations/pl.json';
import pt from './translations/pt.json';
import { AuthContextProvider, initAuthContextProvider } from './services/authContextProvider';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PermissionError from './pages/permissionError/permissionError';
import FullDetail from './pages/fullDetail/fullDetail';
import AdministrationPanel from './pages/administrationPanel/administrationPanel';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/bitter/400.css';
import '@fontsource/bitter/700.css';
import '@fontsource/bitter/400-italic.css'; // Specify weight and style
import AdvancedSearch from './pages/advancedSearch/advancedSearch';
import PendingActions from './pages/pendingActions/pendingActions';
import AllNotifications from './pages/allNotifications/AllNotifications';
import DetailsViewProvider from './context/DetailsViewProvider';
import { consumeAuthReturnUrl, saveAuthReturnUrl } from './services/authReturnUrl';
const defaultLanguage = localStorage.getItem('language') && localStorage.getItem('language') !== '' ? localStorage.getItem('language') : 'es';

void i18next.init({
  interpolation: { escapeValue: false },
  resources: {
    es: {
      default: es
    },
    en: {
      default: en
    },
    pl: {
      default: pl
    },
    pt: {
      default: pt
    }
  },
  defaultNS: 'default',
  lng: defaultLanguage as string,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const renderRoutes = () => {
  root.render(
    <I18nextProvider i18n={i18next}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/error-permisos" element={
            <AuthContextProvider authenticate={false} loadSystemCapabilities={false}>
              <PermissionError error={'permissions'} />
            </AuthContextProvider>} />
          <Route path="/error-usuario" element={
            <AuthContextProvider authenticate={false} loadSystemCapabilities={false}>
              <PermissionError error={'user'} />
            </AuthContextProvider>} />
          <Route path="/" element={
            <AuthContextProvider>
              <App />
            </AuthContextProvider>
          }>
            <Route path="/admin" element={
              <AuthContextProvider>
                <AdministrationPanel />
              </AuthContextProvider>} />
            <Route path="/notificaciones" element={
              <AuthContextProvider>
                <AllNotifications />
              </AuthContextProvider>} />
            <Route path="/acciones-pendientes" element={
              <AuthContextProvider>
                <PendingActions />
              </AuthContextProvider>} />
            <Route path="/busqueda-avanzada" element={
              <AuthContextProvider>
                <AdvancedSearch />
              </AuthContextProvider>} />
            <Route path="/:codCentro/detalles/*" element={
              <DetailsViewProvider>
                <FullDetail />
              </DetailsViewProvider>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </I18nextProvider >
  );
};

// Error pages are deliberately public. If they start OIDC again, a rejected
// session can reload the bundle and produce an endless login/401 loop.
const publicErrorRoute = window.location.pathname === '/error-permisos'
  || window.location.pathname === '/error-usuario';
const oidcCallback = new URLSearchParams(window.location.search).has('code')
  || new URLSearchParams(window.location.search).has('error');

if (publicErrorRoute) {
  renderRoutes();
} else {
  if (!oidcCallback) saveAuthReturnUrl();
  initAuthContextProvider().then((authenticated) => {
    if (!authenticated) return;
    const returnUrl = consumeAuthReturnUrl();
    if (returnUrl && returnUrl !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
      window.history.replaceState({}, '', returnUrl);
    }
    renderRoutes();
  }).catch((error: unknown) => {
    // A failed OIDC callback must be visible and recoverable, not followed by
    // another automatic login redirect that can loop forever.
    console.error('Unable to bootstrap the authentication session', error);
    window.history.replaceState({}, '', '/error-permisos');
    root.render(
      <I18nextProvider i18n={i18next}>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AuthContextProvider authenticate={false} loadSystemCapabilities={false}>
            <PermissionError error={'permissions'} />
          </AuthContextProvider>
        </BrowserRouter>
      </I18nextProvider>
    );
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
